// Keep footer navigation independent of the full policy translation bundle.
export const MIN_PUBLIC_INFO_NAV = {
  "en": {
    "support": "Support",
    "privacy": "Privacy",
    "terms": "Terms"
  },
  "xh": {
    "support": "Inkxaso",
    "privacy": "Ubumfihlo",
    "terms": "Imigaqo"
  },
  "zu": {
    "support": "USekelo",
    "privacy": "Ubumfihlo",
    "terms": "Imigomo"
  },
  "ta": {
    "support": "ஆதரவு",
    "privacy": "தனியுரிமை",
    "terms": "விதிமுறைகள்"
  },
  "te": {
    "support": "సహాయం",
    "privacy": "గోప్యత",
    "terms": "నిబంధనలు"
  },
  "ur": {
    "support": "معاونت",
    "privacy": "رازداری",
    "terms": "شرائط"
  },
  "mr": {
    "support": "मदत",
    "privacy": "गोपनीयता",
    "terms": "अटी"
  },
  "or": {
    "support": "ସହାୟତା",
    "privacy": "ଗୋପନୀୟତା",
    "terms": "ସର୍ତ୍ତାବଳୀ"
  },
  "pa": {
    "support": "ਸਹਾਇਤਾ",
    "privacy": "ਪਰਦੇਦਾਰੀ",
    "terms": "ਸ਼ਰਤਾਂ"
  },
  "hi": {
    "support": "सहायता",
    "privacy": "गोपनीयता",
    "terms": "शर्तें"
  },
  "kn": {
    "support": "ಬೆಂಬಲ",
    "privacy": "ಗೌಪ್ಯತೆ",
    "terms": "ನಿಯಮಗಳು"
  },
  "ml": {
    "support": "പിന്തുണ",
    "privacy": "സ്വകാര്യത",
    "terms": "നിബന്ധനകൾ"
  },
  "af": {
    "support": "Ondersteuning",
    "privacy": "Privaatheid",
    "terms": "Bepalings"
  },
  "bn": {
    "support": "সহায়তা",
    "privacy": "গোপনীয়তা",
    "terms": "শর্তাবলি"
  },
  "gu": {
    "support": "સહાય",
    "privacy": "ગોપનીયતા",
    "terms": "શરતો"
  }
};

export function buildMinPublicInfoPath(locale, page) {
  return `${locale === "en" ? "" : `/l/${encodeURIComponent(locale)}`}/${page}`;
}
